import { render, staticRenderFns } from "./CategoryBrandList.vue?vue&type=template&id=9b78c2ca&scoped=true&"
import script from "./CategoryBrandList.vue?vue&type=script&lang=js&"
export * from "./CategoryBrandList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBrandList.vue?vue&type=style&index=0&id=9b78c2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b78c2ca",
  null
  
)

export default component.exports